import { render } from "./PoliticaBecas.vue?vue&type=template&id=801920b4&scoped=true"
import script from "./PoliticaBecas.vue?vue&type=script&lang=js"
export * from "./PoliticaBecas.vue?vue&type=script&lang=js"

import "./PoliticaBecas.vue?vue&type=style&index=0&id=801920b4&scoped=true&lang=css"

import exportComponent from "D:\\WEB\\LICEO\\CURSOS\\portalalumnoscursos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-801920b4"]])

export default __exports__